import { NameEmailForm } from '@/shared/components/forms';
import type { NameEmailFormData } from '@/shared/components/forms';

interface CaseStudyFormProps {
  title?: string;
}

export const CaseStudyForm = ({
  title = 'Watch a demo of how BrokerMax works:'
}: CaseStudyFormProps) => {
  const handleFormSubmit = async (_data: NameEmailFormData) => {
    // Simulate API call - replace with actual API call
    await new Promise(resolve => setTimeout(resolve, 1000));
  };

  return (
    <div className="container mx-auto max-w-6xl my-20 px-4">
      <div className="text-center mb-8">
        <h2 className="text-4xl lg:max-xl:text-3xl md:max-lg:text-2xl sm:max-md:text-2xl xsm:max-sm:text-xl font-bold text-black mb-4 font-Jakarta">
          {title}
        </h2>
      </div>
      <NameEmailForm
        onSubmit={handleFormSubmit}
        submitText="Watch Demo Now →"
        submittingText="Downloading..."
        namePlaceholder="Enter Your Name*"
        emailPlaceholder="Enter Your Email*"
        variant="case-study"
        onSuccessMessage={data =>
          `Thank you ${data.name}! Your demo video link has been sent to ${data.email}.`
        }
      />
    </div>
  );
};
